import { Button } from '@chakra-ui/react';
import type { ProgramMode } from '@fluenceur/types';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from '@/components/ui/dialog';
import type { ProgramRewardsFormData } from './ProgramRewardsForm';
import ProgramRewardsForm from './ProgramRewardsForm';

interface ProgramRewardsModalProps {
  programId: string;
  programMode?: ProgramMode;
  isOpen: boolean;
  onClose: () => void;
  defaultValues?: Partial<ProgramRewardsFormData>;
}

const ProgramRewardsModal: React.FC<ProgramRewardsModalProps> = ({
  programId,
  programMode,
  isOpen,
  onClose,
  defaultValues,
}) => {
  const { t } = useTranslation();
  const formRef = useRef<{ submit: () => void } | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.submit();
    }
  };

  return (
    <DialogRoot
      open={isOpen}
      lazyMount
      unmountOnExit
      onOpenChange={({ open }) => {
        if (!open) onClose();
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('programs.modals.editRewards.title')}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <ProgramRewardsForm
            ref={formRef}
            programId={programId}
            programMode={programMode}
            defaultValues={defaultValues}
            onSubmitting={setIsSubmitting}
            onSuccess={onClose}
          />
        </DialogBody>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button onClick={handleSubmit} loading={isSubmitting} disabled={isSubmitting}>
            {t('common.save')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};

export default ProgramRewardsModal;
